import { call, put, takeEvery, all } from 'redux-saga/effects'
import faqsTypes from './faqsTypes'
import * as faqsActions from './faqsActions'
import Faqs from '../../services/FaqsService'

export function * getFaqs () {
  try {
    const { data } = yield call(Faqs.fetchFaqs)
    yield put(faqsActions.getFaqsSuccess(data))
  } catch ({ message }) {
    yield put(faqsActions.getFaqsFailure(message))
  }
}

export function * onGetFaqs () {
  yield takeEvery(faqsTypes.GET_FAQS, getFaqs)
}

export function * faqsSaga () {
  yield all([
    call(onGetFaqs)
  ])
}
